import { render, staticRenderFns } from "./OverdueDialog.vue?vue&type=template&id=06b13164&scoped=true"
import script from "./OverdueDialog.vue?vue&type=script&lang=js"
export * from "./OverdueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b13164",
  null
  
)

export default component.exports